<template>
  <router-link class="font-medium text-primary-600 transition ease-in-out duration-150 hover:text-primary-500" :to="to">
    <slot></slot>
  </router-link>
</template>

<script>
export default {
  name: "UiLink",
  props: {
    to: {required: true}
  }
}
</script>

<style lang="scss" scoped>
/*.link {
  @apply rounded-md font-medium text-primary-600 transition ease-in-out duration-150 cursor-pointer;

  &:focus {
    @apply outline-none ring-2 ring-offset-2 ring-primary-500;
    //underline
  }

}*/
</style>